import React from 'react';

const AppContext = React.createContext(null);

export const AppContextProvider = AppContext.Provider;
export const AppContextConsumer = AppContext.Consumer;
